import dayjs from 'dayjs';

import { ClusterResponse, ClusterStatus } from '@cast/types';

import {
  NOT_FOUND_CLUSTER_FAILURE_AGE_DAYS,
  NOT_FOUND_RECONCILE_ERROR_PATTERNS,
} from '../constants';

// TODO: Replace string matching with a stable API field (e.g. reconcile failure reason / error code).
const matchesKnownReconcileError = (errorMessage: string): boolean => {
  const lowerCasedError = errorMessage.toLowerCase();

  return NOT_FOUND_RECONCILE_ERROR_PATTERNS.some((pattern) =>
    lowerCasedError.includes(pattern)
  );
};

const isOlderThanFailureThreshold = (reconciledAt: string): boolean =>
  dayjs(reconciledAt).isBefore(
    dayjs().subtract(NOT_FOUND_CLUSTER_FAILURE_AGE_DAYS, 'day')
  );

export const isNotFoundCluster = (cluster: ClusterResponse): boolean => {
  if (cluster.status !== ClusterStatus.FAILED) {
    return false;
  }

  const errorMessage =
    cluster.reconcileError || cluster.reconcileInfo?.error || '';

  if (matchesKnownReconcileError(errorMessage)) {
    return true;
  }

  const reconciledAt =
    cluster.reconcileInfo?.reconciledAt || cluster.reconcileInfo?.startedAt;

  return Boolean(reconciledAt && isOlderThanFailureThreshold(reconciledAt));
};
